import { useBankingSDKRecipientsActions } from "features/openBanking/actions";
import { useOpenBankingResource } from "../shared/OpenBankingResource";

export default function useBankingSDKRecipients() {
    const { onRowClick } = useOpenBankingResource();

    const {
        getBankingSdkRecipients: getResource,
        downloadCsv
    } = useBankingSDKRecipientsActions();

    return {
        downloadCsv,
        getResource,
        onRowClick
    };
};
